import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material";
import theme from "./Theme";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material/styles";

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </ThemeProvider>
  </BrowserRouter>,

  document.getElementById("root")
);

reportWebVitals();
